<template>
  <div class="w100 pt20 bg-w">
    <p class="pb10 font-18 tx-c">我的事务</p>
    <TabBar v-model="active" :tab-data="tabData"></TabBar>
    <component :is="active" />
  </div>
</template>

<script>
import TabBar from "@/components/public/TabBar";
import OfficeCardNeed from "@/components/officeCard/OfficeCardNeed";
import OfficeCardDone from "@/components/officeCard/OfficeCardDone";
import OfficeCardLaunch from "@/components/officeCard/OfficeCardLaunch";

export default {
  name: "OfficeCard",
  components: {
    TabBar,
    OfficeCardNeed,
    OfficeCardDone,
    OfficeCardLaunch
  },
  props: [],
  data() {
    return {
      active: "OfficeCardNeed",
      tabData: [
        {
          index: "OfficeCardNeed",
          name: "待处理"
        },
        {
          index: "OfficeCardDone",
          name: "已处理"
        },
        {
          index: "OfficeCardLaunch",
          name: "我发起"
        }
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
